const ACTION_CODE_PATTERN = /^[a-z][a-z0-9_]*(?:\.[a-z][a-z0-9_]*){2,}$/

export function normalizeActionCode (value) {
  const code = typeof value === 'string' ? value.trim() : ''
  return ACTION_CODE_PATTERN.test(code) ? code : ''
}

export function normalizeRequiredActions (value) {
  const values = Array.isArray(value) ? value : [value]
  if (!values.length) return []
  const seen = Object.create(null)
  const result = []
  for (let item of values) {
    const code = normalizeActionCode(item)
    // A partly malformed policy must not become less restrictive by dropping
    // only its invalid members.
    if (!code) return []
    if (seen[code]) continue
    seen[code] = true
    result.push(code)
  }
  return result
}

function actionLookup (actionCodes) {
  const lookup = Object.create(null)
  if (!Array.isArray(actionCodes)) return lookup
  actionCodes.forEach(value => {
    const code = normalizeActionCode(value)
    if (code) lookup[code] = true
  })
  return lookup
}

export function can (actionCodes, requiredAction) {
  const required = normalizeActionCode(requiredAction)
  if (!required) return false
  return Boolean(actionLookup(actionCodes)[required])
}

export function canAny (actionCodes, requiredActions) {
  const required = normalizeRequiredActions(requiredActions)
  if (!required.length) return false
  const granted = actionLookup(actionCodes)
  return required.some(code => granted[code])
}

export function canAll (actionCodes, requiredActions) {
  const required = normalizeRequiredActions(requiredActions)
  if (!required.length) return false
  const granted = actionLookup(actionCodes)
  return required.every(code => granted[code])
}



// WEBPACK FOOTER //
// ./src/utils/access.js